<template>
    <div></div>
</template>

<script>
    export default {
        data() {
            return {
                query: this.$route.query.token ? this.$route.query.token : ''
            }
        },
        methods: {
            async CLIENT_SSO_TRANSFORM(token) {
                try {
                    let response = await this.$store.dispatch('CLIENT_SSO_TRANSFORM', {jwt: token})
                    if(response && response.status === 200) {
                        this.$router.push('/members/dashboard')
                    } else {
                        this.goToLogin()
                    }

                }catch(e) {
                    console.log(e.response)
                }
            },
            goToLogin() {
                this.$router.push('/members/sign-in')
            }
        },
        created() {
            if(this.query) {
                let token = this.$jwt.decode(this.query);
                if(token) {
                    console.log(token, 'TOKEN')
                    if('grd' in token) {
                        console.log(token, 'token here grd')
                        this.goToLogin()
                    } else {
                        console.log('fire API')
                        this.CLIENT_SSO_TRANSFORM(this.query)
                    }
                } else {
                    this.goToLogin()
                }

            } else {
                this.goToLogin()
            }
        }
    }
</script>